var CONFUSEDWEBSITE = CONFUSEDWEBSITE || {},
    CSSCONSTANTS = CSSCONSTANTS || {};

(function ($) {

    /* THIS MUST RUN ON DOM READY AND ALSO AFTER WEB FONTS HAVE LOADED TO AVOID JARRING PAGE JUMPS */

    CONFUSEDWEBSITE.setupEqualizeHeights = function () {

        var $groupsToEqualize;
            
        CONFUSEDWEBSITE.addEqualizeHeightsClasses();

        enquire.register(CSSCONSTANTS.nonMobileMinWidthMQ, {

            match: function () {
                /* equalize all the groups */
                $groupsToEqualize = $('.' + CSSCONSTANTS.equalizeHeightSetNonMobileClass);
                CONFUSEDWEBSITE.equalizeHeights($groupsToEqualize, '.' + CSSCONSTANTS.equalizeHeightNonMobileClass);
            },
            unmatch: function () {
                /* remove heights when on mobile */
                CONFUSEDWEBSITE.removeHeights('.' + CSSCONSTANTS.equalizeHeightNonMobileClass);
            }
        }, true);

        enquire.register(CSSCONSTANTS.desktopMinWidthMQ, {

            match: function () {
                /* equalize all the groups */
                $groupsToEqualize = $('.' + CSSCONSTANTS.equalizeHeightSetDesktopClass);
                CONFUSEDWEBSITE.equalizeHeights($groupsToEqualize, '.' + CSSCONSTANTS.equalizeHeightDesktopClass);
            },
            unmatch: function () {
                /* remove heights when on mobile */
                CONFUSEDWEBSITE.removeHeights('.' + CSSCONSTANTS.equalizeHeightDesktopClass);
            }
        }, true);

        $(window).on('resize', function () {

            /* when window resized, remove the heights... */
            CONFUSEDWEBSITE.removeHeights('.' + CSSCONSTANTS.equalizeHeightNonMobileClass);
            CONFUSEDWEBSITE.removeHeights('.' + CSSCONSTANTS.equalizeHeightDesktopClass);

            /* and then listen again for the non-mobile size */
            enquire.register(CSSCONSTANTS.nonMobileMinWidthMQ, {
                match: function () {
                    $groupsToEqualize = $('.' + CSSCONSTANTS.equalizeHeightSetNonMobileClass);
                    CONFUSEDWEBSITE.equalizeHeights($groupsToEqualize, '.' + CSSCONSTANTS.equalizeHeightNonMobileClass);
                }
            }, true);

            enquire.register(CSSCONSTANTS.desktopMinWidthMQ, {
                match: function () {
                    $groupsToEqualize = $('.' + CSSCONSTANTS.equalizeHeightSetDesktopClass);
                    CONFUSEDWEBSITE.equalizeHeights($groupsToEqualize, '.' + CSSCONSTANTS.equalizeHeightDesktopClass);
                }
            }, true);

        });
    };

    CONFUSEDWEBSITE.addEqualizeHeightsClasses = function () {
        /* create parent classes that group items we intend to equalize heights of */
        var $elementsToAdjustDesktop = $('.' + CSSCONSTANTS.equalizeHeightDesktopClass),
            $elementsToAdjustNonMobile = $('.' + CSSCONSTANTS.equalizeHeightNonMobileClass),
            parentSelector = '.row';
            
        /* add parent class to nearest row identify as unique set */
        $.each($elementsToAdjustDesktop, function () {
            var $this = $(this),
                $parentRow = $this.closest(parentSelector);

            $parentRow.addClass(CSSCONSTANTS.equalizeHeightSetDesktopClass);
        });

        $.each($elementsToAdjustNonMobile, function () {
            var $this = $(this),
                $parentRow = $this.closest(parentSelector);

            $parentRow.addClass(CSSCONSTANTS.equalizeHeightSetNonMobileClass);
        });

    };

    CONFUSEDWEBSITE.equalizeHeights = function ($groupsToEqualize, elementsToAdjustSelector) {
		
		$.each($groupsToEqualize, function() {
			var $this = $(this),
				$items = $this.find(elementsToAdjustSelector),
				highest = 0;
				
			$.each($items, function() {
				var $this = $(this),
					thisHeight = $this.outerHeight();
					
				if (thisHeight > highest) {
					highest = thisHeight;
				}
			});
			
			$.each($items, function() {
				$(this).css('height', highest);
			});
		});
	};

    CONFUSEDWEBSITE.removeHeights = function (elementsToAdjustSelector) {
        $(elementsToAdjustSelector).css('height', 'auto');
	};


})(window.jQuery);